
import ProductService from "app/services/productService";
import axios from "axios";
import Label from "components/Label/Label";
import React, { ChangeEvent, FC, useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
// import Select from "shared/Select/Select";
import Textarea from "shared/Textarea/Textarea";

import Select, { MultiValue, PropsValue, SingleValue } from 'react-select'

import { Helmet } from "react-helmet-async";

import toast from "react-hot-toast";
import Notify from "components/Notify";
import { DeleteIcon, DeliveryIcon, RefundsIcon, ReturnIcon, ShippingIcon } from "components/icons";
import { ShippingValue } from "data/data";
import Dash from "containers/dash";
import { SketchPicker, CirclePicker, BlockPicker  } from 'react-color'

const apiUrl = process.env.REACT_APP_API_URL
type SelectValue =  {
    value: any;
    label: any
}

type ColorValue =  {
    id: number;
    color: string
}

type SizeValue =  {
    label: string;
    value: number
}

type SizeValueDb =  {
    value: string;
    id: number
}
interface ColorProps{
    id: number;
    color: string
    onClick?: any 
    toggle: boolean
}

interface ColorsProps{
    colors: ColorValue[]
    cheked: ColorValue[]
    display: boolean
    onChange?:any
    onClose?:any
}

const ColorBox =  ({color, id, onClick, toggle}: ColorProps) =>{
    const [toggleSelection, setToggleSelection] = useState<boolean>(toggle)
    const onSelect = (e: React.MouseEvent<HTMLElement>) =>{
        const color = e.currentTarget.getAttribute('data-color');
        const id = e.currentTarget.getAttribute('data-id');
        console.log(id, color)
        
        const toggle = !toggleSelection
        onClick({id:id, color:color}, toggle)
        setToggleSelection(toggle)
    }
    useEffect(()=>{
        setToggleSelection(toggle)
        
    }, [toggle])
    return(
        <div 
            data-color={color} 
            data-id={id} 
            onClick={onSelect} 
            className="h-6 w-6 ml-2 rounded flex justify-center items-center cursor-pointer" 
            style={{backgroundColor: color}}>{toggleSelection ? "✓" : ""}</div>
    )
}
const ColorPicker: FC<ColorsProps> = ({cheked, colors, display, onChange, onClose}) => {
    const [selectedColors, setSelectedColors] = useState<ColorValue[]>([])

    const onSelect = (color:ColorValue, toggle: boolean) =>{
        let newColor = selectedColors

        if(!selectedColors.filter(c => c.id == color.id).length)
            newColor = [...newColor, color]
        if(!toggle)
            newColor = selectedColors.filter(c => c.id != color.id)
        setSelectedColors(newColor)
        onChange(newColor)
    }

    
    useEffect(()=>{
        setSelectedColors(cheked)
        
    }, [cheked])
    return(
        <div className= {` ${display ?  '' : 'hidden'  } bg-gray-50  absolute z-10 drop-shadow-md`} >

    
            <div className={`  grid grid-rows-3 grid-flow-col gap-1  p-2`}>
                {
                    colors.map((c, i) => {
                        return(
                            <ColorBox
                                key={i}
                                onClick={onSelect}
                                id={c.id}
                                color={c.color}
                                toggle={selectedColors.map(c => c.id).includes(c.id)}
                            />
                        )
                    })
                }
                
            </div>
            <div className="" onClick={() => onClose(false)}>close</div>
        </div>
    )
}
const EditProduct = () => {
    let {  id } = useParams();

    const [images, setImage] = useState<string[]>([])
    const [productId, setProductId] = useState<number>(0);
    const [name, setName] = useState<string>("");
    const [price, setPrice] = useState<number>(0);
    const [size, setSize] = useState<MultiValue<SelectValue>>([{value:5, label:'M'}]);
    const [condition, setCondition] = useState<SingleValue<SelectValue>>({value:'2', label: 'Comme neuf'});


    const [category, setCategory] = useState<SingleValue<SelectValue>>();

    const [description, setDescription] =  useState<string>("");
    const [quantity, setQuantity] = useState<number>(1);
    const [photos, setPhotos] = useState<any[]>([]);

    const [categories, setCategories] = useState<any[]>([]);
    const [shipping, setShipping] = useState<ShippingValue[]>([])
    const [colors, setColors] = useState<ColorValue[]>([])
    const [colorsPikerShow, setColorsPikerShow] = useState<boolean>(false)
    const [colorsList, setColorsList] = useState<ColorValue[]>([])
    const [sizeList, setSizeList] = useState<SizeValue[]>([])
    const navigate =  useNavigate();


    // const loadBookFromServer = useCallback(async () => {
    //     let response = await ProductService.chekDraft()
    //     // response  = await response.json() 
    //     console.log(response)
    //     setName(response.name)
    //     setCategory({value: response.category_id, label: response.category})
    //   }, [])

    const  conditionVal = (v: number) => {
        switch(v){
            case 1: return  'Neuf'; break;
            case 2: return  'Comme neuf'; break;
            case 3: return  'Bon etat'; break;
         
        }
    }

    
    const handleColorChange = (hex : any ) => console.log(hex)
    
  
    useEffect(() => {
        ProductService.getColors().then(d =>{
            setColorsList(d)
        })

        ProductService.getSizes().then(d =>{
            const data : SizeValueDb[] = d
            const val = data.map((s)=> {
                return {label: s.value, value :s.id }
            })
            setSizeList(val)
            console.log(d)
        })
        ProductService.getProduitById(String(id)).then(d =>{

         if(d.detail){
            // console.log(d.detail)
            toast.custom((t) => (<Notify 
                t={t}
                message='Votre suscrption actule vouz permet pas de publier plus de produits!'
                status='warning'
            />))
            
          
            //  sendNotification("warning", "Warning!", "Votre suscrption actule vouz permet pas de publier plus que 3 article!")
            //  navigate('/');
             navigate("/abonnement");
         }
        
            setName(d.name)
            setPrice(d.price)
            setPhotos(d.medias)
            setDescription(d.description)
            setProductId(d.id)
            setCategory({value: d.category_id, label:d.category})
            setQuantity(d.quantity)
            
            setSize(
                d.size.map((s:any) => {
                    return {value: s.id, label: s.value}
                })
                
                )
            setColors(d.colors)
            setCondition({value: d.condition, label: conditionVal(d.condition)})
            setShipping(d.shipping)

        })
        // loadBookFromServer()
        ProductService.getCategoriesList().then(c => setCategories(c))
       
     }, [ ]);
   
    const saveSubmit =  (typeSave: string) => {
       
        const data = {
            id: id,
            name: name,
            price: price,
            category_id:  category?.value,
            description: description,
            size_id: size.map(s => s.value),
            condition:   condition?.value,
            draft: true,
            shipping: shipping,
            quantity: quantity,
            colors_id: colors.map(c => c.id)

        }
        let message = 'votre brouillon a bien ete sauvegardé!'
        if(typeSave == 'brouillon')
            data['draft'] = true
        if(typeSave == 'Sauvegarder'){
            data['draft'] = false
            message = 'votre produit a bien ete sauvegardé!'
        }
            
        console.log(data)
        ProductService.editProduits(data).then(np =>{
            toast.custom((t) => (
                <Notify 
                    t={t}
                    message={message}
                    status ='success'
                />),
                { position: "top-right", id: "nc-product-notify", duration: 3000 }
            )
            if(data.draft == false)
                navigate("/");
           
        })
    }
    const loginData = localStorage.getItem('loginData')
    ? JSON.parse(localStorage.getItem('loginData')!)
    : {
      authChecked: false,
      loggedIn: false,
      token: ""
    }
    const selectFileHandler = (event: ChangeEvent<HTMLInputElement>) =>{
        const { files } = event.target;

        if(files && files[0]){
            
            for(let i=0; i < files.length; i++){
                setImage(images => [... images, URL.createObjectURL(files[i]) ])
                const fd = new FormData();
                fd.append('file',  files[i])
                fd.append('product_id', `${productId}`)

                axios.post(`${apiUrl}/api/media/product`, fd, {
                    headers: {
                        'Authorization': `Bearer ${loginData.token}`, // notice the Bearer before your token
                    }
                } ).then(
                    response =>  {
                        const data = response.data
                  
                        setPhotos(photos => [... photos, data])
                    }
                )
               
            }
            // setImage(images => [... images, URL.createObjectURL(files[0]) ])
            // const fd = new FormData();
            // fd.append('file',  files[0])
            // fd.append('product_id', `${productId}`)

            // axios.post(`${apiUrl}/api/media/product`, fd, {
            //     headers: {
            //         'Authorization': `Bearer ${loginData.token}`, // notice the Bearer before your token
            //     }
            // } ).then(
            //     response =>  {
            //         const data = response.data
            //         setPhotos(photos => [... photos, data])
            //     }
            // )


        }

    }

    const deletePhotoHandler = (event: any) => {
        const id =  event.target.id

        ProductService.deletePhoto(id).then( response =>{

            const data =  photos.filter(function( obj ) {
                return obj.id !== response.id;
            });
            setPhotos(data)
        }

        )
    }


  
    return (

    
      <Dash>
      <Helmet>
        <title>Roupa | Modifier un produit </title>
      </Helmet>
      <div className=" ">
        <div className="flex  ">
        <div className="w-[50%] p-10" >
            <div>
                <Label>Nom du produit</Label>
                <Input className="mt-1.5"
                name="productName"
                value={name} onChange={e => setName(e.target.value)} required/>
            </div>
            <div>
                <Label>Le prix</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                  <i className="text-2xl las la-money-bill-wave-alt"></i>
                  </span>
                  <Input
                    type="number"
                    className="!rounded-l-none"
                    placeholder="1000"
                    name="price"
                    value={price} onChange={e => setPrice(parseInt(e.target.value))}required
                  />
                </div>
            </div>
            <div>
                <Label>Catégorie</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                  <i className="text-2xl las la-list"></i>

                  </span>
                {/* <Select  className="!rounded-l-none" value={category} name="category" onChange={e => setCategory(parseInt(e.target.value))} required>
                <option value=""  hidden >Chose category</option>

                {
                    categories.map((c,i) => {
                        return   <option key={i} value={c.id}>{c.name}</option>
                    })
                }
                </Select> */}
                
                {/* block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 disabled:bg-neutral-200 dark:disabled:bg-neutral-800 */}
                <Select name="category"   className=" w-full " options={
                        categories.map(c => {
                            return {value : c.id, label: c.name}
                        })
                    }  
                    value={category}
                    placeholder='Choisir une catégorie'
                    onChange={e => setCategory(e) } required
                />
                </div>
            </div>
            <div>
                <Label>Coleurs</Label>
                <div className="mt-1.5 flex">
                    
                
                    {
                        colors.map((c, i) =>{
                            return (
                                <>
                                <span 
                                    className="h-6 w-6 ml-2 rounded"
                                    style={{backgroundColor: c.color}} 
                                   
                                    ></span>
                               
                                </>
                            )
                        })
                    }
                    <div style={{ position: 'relative' }}>
                 
                        <span 
                        className="h-6 w-6 ml-2 rounded border-dashed border-2 border-zinc-400 flex justify-center items-center "
                        onClick={() =>{
                            setColorsPikerShow(true)
                        }}
                        > + </span>
                        <ColorPicker 
                            onChange={setColors}
                            cheked={colors}
                            colors={colorsList} 
                            display={colorsPikerShow}
                            onClose={setColorsPikerShow}
                        />
                 
                    </div>
                    
                </div>
            </div>
            <div>
                <Label>Taille</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                  <i className="text-2xl las la-crop-alt"></i>

                  </span>
                  {
                   
                  }
                  <Select isMulti className=" w-full " placeholder='Choisir la taille' 
                  options={ sizeList}   name="size" 
                  value={size} 
                  onChange={e => setSize(e) } required
                  />
                    {/* <Select  className="!rounded-l-none" value={size} name="size" onChange={e => setSize(e.target.value)}  required>
                        <option value=""  hidden >Chose size</option>
                        <option value="S"   >S</option>
                        <option value="M"   >M</option>
                        <option value="L"   >L</option>
                        <option value="XL"   >XL</option>
                        <option value="Autre"   >Autre</option>
                    </Select> */}
                </div>

            </div>

            <div>
                <Label>Etat du produit</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                  <i className="text-2xl las la-tshirt"></i>

                  </span>
                  <Select  name="condition"  className=" w-full "  
                  value={condition }
                  options={ [
                    {value:'1', label: 'Neuf'}, 
                    {value:'2', label: 'Comme neuf'}, 
                    {value:'3', label: 'Bon etat'}, 

                  ]} 
                  placeholder="Choisir l'etat du produit"
                  onChange={e => setCondition(e) } 
                  required
                  />
                {/* <Select  className="!rounded-l-none"  value={condition} name="condition" onChange={e => setCondition(parseInt(e.target.value))}  required>
                        <option value=""  hidden >Chose etat du produit</option>
                        <option value="1"   >Neuf</option>
                        <option value="2"   >Comme neuf</option>
                        <option value="3"   >Bon etat</option>
                    </Select> */}
                </div>

            </div>

            <div>
                <Label>Description</Label>
                <Textarea className="mt-1.5" onChange={e => setDescription(e.target.value)} value={description} name="description" />
            </div>

            <div>
                <Label>Quantity</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                  <i className="text-2xl las la-money-bill-wave-alt"></i>
                  </span>
                  <Input
                    type="number"
                    className="!rounded-l-none"
                    placeholder="1000"
                    name="price"
                    value={quantity} onChange={e => setQuantity(parseInt(e.target.value))}required
                  />
                </div>
            </div>
          
            
        </div>
        <div className="w-[50%] p-10">
        <div >
                <Label>Photos</Label>
                <div className="flex w-full overflow-x-auto">

                    {
                                photos.map((ph,i) => {
                                    return (

                                        <div className="rounded-lg min-w-[120px] h-32 mr-4 relative"  key={i}>

                                            <img className="rounded-lg object-cover w-32 h-32 drop-shadow-xl" src={`${apiUrl}/api/media/${ph.name}`}></img>
                                            <i onClick={deletePhotoHandler} id={ph.name} className="las la-trash-alt absolute top-0 p-1 text-2xl text-red-600"></i>
                                        </div>
                                    )
                                })
                            }
                    {
                        photos.length < 8 ?
                    
                        <div className="flex  items-center w-full">
                            <label htmlFor="dropzone-file" className="flex flex-col justify-center  w-32 h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                <div className="flex flex-col items-center justify-center pt-5 pb-6">

                                    <svg className="w-10 h-10 " fill="none" stroke="currentColor"  viewBox="0 0 512 512">
                                        <path d="M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/></svg>
                                </div>
                                <input id="dropzone-file" onChange={selectFileHandler}  type="file" className="hidden"  multiple />
                            </label>
                        </div>
                        : null
                    }
                   
                </div>
            </div>

            <div>
                <Label>Condition de livraison gratuit </Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                  <ShippingIcon/>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    placeholder="Sur les commandes de plus de 10000da"
                    name="shipping"
                    defaultValue={shipping.filter(v => v.type == 'shipping')[0]?.message}
                    onChange={e => setShipping(prevState => {
                        prevState.filter(v => v.type == 'shipping')[0].message  = e.target.value
                        return prevState
                    })} 
                  />

{/* [...shipping, {type:'shipping', message: e.target.value}] */}
                </div>
            </div>
            <div>
                <Label>Condition de retour</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                  <ReturnIcon/>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    placeholder="Frais de retour à la charge du client"
                    name="return"
                    defaultValue={shipping.filter(v => v.type == 'return')[0]?.message}
                    
                    onChange={e => setShipping(prevState => {
                        prevState.filter(v => v.type == 'return')[0].message  = e.target.value
                        return prevState
                    })} 
                  />
                </div>
            </div>
            <div>
                <Label>Livraison nationale</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                  <DeliveryIcon/>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    placeholder="Livraison rapide sur 57 wilayas"
                    name="delivery"
                    defaultValue={shipping.filter(v => v.type == 'delivery')[0]?.message}

                    onChange={e => setShipping(prevState => {
                        prevState.filter(v => v.type == 'delivery')[0].message  = e.target.value
                        return prevState
                    })} 
                  />
                </div>
            </div>
            <div>
                <Label>Politique de remboursement</Label>
                <div className="mt-1.5 flex">
                  <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                  <RefundsIcon/>
                  </span>
                  <Input
                    className="!rounded-l-none"
                    placeholder="60 jours de retour pour quelque raison que ce soit"
                    name="refunds"
                    defaultValue={shipping.filter(v => v.type == 'refunds')[0]?.message}
                    onChange={e => setShipping(prevState => {
                        prevState.filter(v => v.type == 'refunds')[0].message  = e.target.value
                        return prevState
                    })} 
                  />
                </div>
            </div>
            <div className="pt-10">
         
            <ButtonPrimary  type="submit" onClick={ () => saveSubmit('brouillon')}>Brouillon</ButtonPrimary> 
            <ButtonPrimary onClick={ () => saveSubmit('Sauvegarder')}>Sauvegarder</ButtonPrimary>
            </div>
        </div>
        </div>
      </div>
      </Dash>
    
  );
};

export default EditProduct;
